import { render } from "./aboutComponent.vue?vue&type=template&id=9d53514a&scoped=true"
import script from "./aboutComponent.vue?vue&type=script&lang=js"
export * from "./aboutComponent.vue?vue&type=script&lang=js"

import "./aboutComponent.vue?vue&type=style&index=0&id=9d53514a&scoped=true&lang=css"

import exportComponent from "F:\\work\\rahul\\mangal karyala\\gore-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d53514a"]])

export default __exports__